import Vue from 'vue'
import vuetify from '@/plugins/vuetify';
import dialogConfirm from '@/components/dialogs/dialogConfirm'
import wsService from '@/util/ws/wsService'
import behaviorsConstant from "@/constants/behavior.js"
import entityNameConstant from "@/constants/entityName.js"
import actionDataTypeConstant from "@/constants/actionDataType.js"
import actionTypeConstant from "@/constants/actionType.js"
import unitTypeConstant from "@/constants/unitType.js"
import itemTypeConstant from "@/constants/itemType.js"
import actionResponseConstant from "@/constants/actionResponse.js"
import fieldCustomTypeConstant from "@/constants/fieldCustomType.js"
import readTypeConstant from "@/constants/readType.js"
import typesDataConstant from "@/constants/typeData.js"
import typesDataNativeConstant from "@/constants/typeDataNative.js"
import timeTypeConstant from "@/constants/timeType.js"
import accessConstant from "@/constants/access.js"
//import appSettings from "../../appsettings.json"
import authService from "@/services/authService.js"
import i18n from "@/plugins/i18n.js"
import loadingFull from '@/components/loadings/loadingFull'
import locales from "@/constants/locales.js";
import exportFromJSON from "export-from-json";
import snackBarGlobal from '@/components/snackBars/snackBarGlobal'
import packageConfig from '../../package.json'



export default () => {

    const bus = new Vue();

    // global

    Vue.prototype.$version = packageConfig.version;
    Vue.prototype.$http = wsService;
    Vue.prototype.$rowsLimit = !process.env.VUE_APP_ROWS_LIMIT ? 30 : Number.parseInt(process.env.VUE_APP_ROWS_LIMIT)
    Vue.prototype.$bus = bus;
    Vue.prototype.$typesData = typesDataConstant;
    Vue.prototype.$typesDataNative = typesDataNativeConstant;
    Vue.prototype.$entityName = entityNameConstant;
    Vue.prototype.$fieldCustomType = fieldCustomTypeConstant;
    Vue.prototype.$readTypes = readTypeConstant;
    Vue.prototype.$timeTypes = timeTypeConstant;
    Vue.prototype.$behaviors = behaviorsConstant;
    Vue.prototype.$actionDataType = actionDataTypeConstant;
    Vue.prototype.$actionType = actionTypeConstant;
    Vue.prototype.$unitTypes = unitTypeConstant;
    Vue.prototype.$itemTypes = itemTypeConstant;
    Vue.prototype.$actionResponse = actionResponseConstant;
    Vue.prototype.$access = accessConstant;
    Vue.prototype.$auth = authService;
    Vue.prototype.$locales = locales;
    Vue.prototype.$toExcel = (json, name) => {
        exportFromJSON({
            data: json,
            fileName: name == null ? 'data' : name,
            exportType: "xls"
        });
    };
    Vue.prototype.$isRequiredRule = [v => v != null || i18n.t('errors.fieldRequired')]

    // confirm dialog
    Vue.prototype.$confirm = async (title, text) => {
        const dialog = new Vue({ vuetify, i18n, render: g => g(dialogConfirm) }).$mount();
        let dialogConfirmElChildren = dialog.$children[0];
        document.body.appendChild(dialog.$el);
        return await dialogConfirmElChildren.confirm(title, text);
    };

    // snackBar Global (notifications)

    Vue.prototype.$notification = (msg, type) => {
        const snackBar = new Vue({ vuetify, i18n, render: g => g(snackBarGlobal) }).$mount();
        console.log(snackBar)
        let snackBarConfirmElChildren = snackBar.$children[0];
        document.body.appendChild(snackBarConfirmElChildren.$el);
        snackBarConfirmElChildren.show(msg, type);
    };

    // loading full
    const loading = new Vue({ vuetify, i18n, render: g => g(loadingFull) }).$mount();
    const loadingChildren = loading.$children[0];

    Vue.prototype.$loading = (open) => {
        if (open == true || open == null) document.body.appendChild(loading.$el);
        return loadingChildren.active(open);
    };


    Vue.prototype.$toBase64 = (file, full) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(full ? reader.result : reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    Vue.prototype.$bodySize = () => {

        var win = window,
            doc = document,
            docElem = doc.documentElement,
            body = doc.getElementsByTagName("body")[0],
            x = win.innerWidth || docElem.clientWidth || body.clientWidth,
            y = win.innerHeight || docElem.clientHeight || body.clientHeight;
        return { width: x, height: y }
    }

}